var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"numberScrolling",domProps:{"textContent":_vm._s(`${_vm._valFormatHandler(_vm.val, _vm.unit)}`)}})
}
var staticRenderFns = []

export { render, staticRenderFns }